// Action Type
export const GPS_TRENDING_KEYWORDS = 'GPS_TRENDING_KEYWORDS'

// Action
export const setGPSTrendingKeywords = gps_keywords => ({ type: GPS_TRENDING_KEYWORDS, gps_keywords })
// Selector
export const getGPSTrendingKeywords = state => state

// Reducer
export default (state = [], action = {}) => {
    switch (action.type) {
        case GPS_TRENDING_KEYWORDS:
            return [...action.gps_keywords]
        default:
            return state
    }
}
